import React from 'react';
import ModernCTA from '../../components/ModernCTA';

const MobileInnovation = () => {
  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Mobile Innovation</h1>
          <p style={styles.heroSubtitle}>
            Cutting-edge cross-platform apps with Flutter and React Native, enhanced with immersive AR/VR experiences.
          </p>
        </div>
        <div style={styles.phoneIllustration}>
          <div style={styles.phone}>
            <div style={styles.screen}>
              <div style={styles.appInterface}></div>
            </div>
          </div>
          <div style={styles.arElements}>
            <div style={styles.arCube}></div>
            <div style={styles.arSphere}></div>
          </div>
        </div>
      </section>

      {/* Frameworks Section */}
      <section style={styles.frameworks}>
        <div style={styles.sectionHeader}>
          <span style={styles.sectionTag}>TECHNOLOGIES</span>
          <h2 style={styles.sectionTitle}>Cross-Platform Excellence</h2>
          <p style={styles.sectionDescription}>
            We deliver native-like performance across iOS and Android with modern frameworks.
          </p>
        </div>

        <div style={styles.frameworkGrid}>
          <div style={styles.frameworkCard}>
            <div style={styles.frameworkLogo}>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12L3.5 7M12 12V21M12 12L20.5 7M12 12L12 3M12 21L3.5 16M12 21L20.5 16M12 3L3.5 7.5M12 3L20.5 7.5" stroke="#02569B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 style={styles.frameworkTitle}>Flutter Development</h3>
            <p style={styles.frameworkText}>
              Beautiful, natively compiled applications for mobile, web, and desktop from a single codebase with Google's UI toolkit.
            </p>
            <div style={styles.frameworkFeatures}>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>Hot reload for rapid development</span>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>Custom widget architecture</span>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>120fps animations</span>
              </div>
            </div>
          </div>

          <div style={styles.frameworkCard}>
            <div style={styles.frameworkLogo}>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 15.5L12 12V2L6.5 15.5Z" stroke="#61DAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 12L17.5 8.5L12 2V12Z" stroke="#61DAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M17.5 15.5L12 12V22L17.5 15.5Z" stroke="#61DAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.5 8.5L12 12L17.5 15.5L12 22L6.5 8.5Z" stroke="#61DAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 style={styles.frameworkTitle}>React Native</h3>
            <p style={styles.frameworkText}>
              Build truly native apps using React with access to platform APIs and native components when you need them.
            </p>
            <div style={styles.frameworkFeatures}>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>Reusable React components</span>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>Native module integration</span>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>✓</div>
                <span>Large ecosystem support</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AR/VR Section */}
      <section style={styles.arvrSection}>
        <div style={styles.arvrContent}>
          <div style={styles.arvrText}>
            <span style={styles.sectionTag}>IMMERSIVE TECH</span>
            <h2 style={styles.sectionTitle}>AR/VR Integration</h2>
            <p style={styles.arvrDescription}>
              We bring immersive experiences to mobile apps with cutting-edge augmented and virtual reality technologies.
            </p>
            <div style={styles.arvrCapabilities}>
              <div style={styles.capability}>
                <h4 style={styles.capabilityTitle}>ARKit/ARCore</h4>
                <p style={styles.capabilityText}>
                  Platform-specific AR implementations with advanced tracking and environmental understanding.
                </p>
              </div>
              <div style={styles.capability}>
                <h4 style={styles.capabilityTitle}>Unity Integration</h4>
                <p style={styles.capabilityText}>
                  High-fidelity 3D experiences and games embedded in your mobile applications.
                </p>
              </div>
              <div style={styles.capability}>
                <h4 style={styles.capabilityTitle}>WebXR</h4>
                <p style={styles.capabilityText}>
                  Browser-based AR/VR experiences that work across devices without app installation.
                </p>
              </div>
            </div>
          </div>
          <div style={styles.arvrVisual}>
            <div style={styles.arvrDevice}>
              <div style={styles.arvrScreen}>
                <div style={styles.arvrElements}>
                  <div style={styles.arvrObject}></div>
                  <div style={styles.arvrObject}></div>
                  <div style={styles.arvrPlane}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section style={styles.caseStudies}>
        <div style={styles.sectionHeader}>
          <span style={styles.sectionTag}>SUCCESS STORIES</span>
          <h2 style={styles.sectionTitle}>Mobile Transformations</h2>
        </div>

        <div style={styles.studyGrid}>
          <div style={styles.studyCard}>
            <div style={styles.studyHeader}>
              <div style={styles.studyLogo}></div>
              <h3 style={styles.studyTitle}>Retail AR App</h3>
            </div>
            <p style={styles.studyText}>
              Flutter app with AR product visualization increased conversions by 65% and reduced returns by 40%.
            </p>
            <div style={styles.studyStats}>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>65%</span>
                <span style={styles.statLabel}>Conversion Lift</span>
              </div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>40%</span>
                <span style={styles.statLabel}>Fewer Returns</span>
              </div>
            </div>
          </div>

          <div style={styles.studyCard}>
            <div style={styles.studyHeader}>
              <div style={styles.studyLogo}></div>
              <h3 style={styles.studyTitle}>Healthcare VR</h3>
            </div>
            <p style={styles.studyText}>
              React Native app with VR therapy modules improved patient engagement by 80% and treatment adherence.
            </p>
            <div style={styles.studyStats}>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>80%</span>
                <span style={styles.statLabel}>Engagement</span>
              </div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>3x</span>
                <span style={styles.statLabel}>Adherence</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <ModernCTA />
    </div>
  );
};

const styles = {
  container: {
    marginTop: '110px',
    color: '#ffffff',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    lineHeight: 1.6,
    overflowX: 'hidden',
  },
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px 5%',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      textAlign: 'left',
      justifyContent: 'space-between',
      padding: '80px 5%',
    },
  },
  heroContent: {
    maxWidth: '600px',
    marginBottom: '40px',
    '@media (min-width: 768px)': {
      marginBottom: 0,
    },
  },
  heroTitle: {
    fontSize: '2.5rem',
    fontWeight: 800,
    lineHeight: 1.2,
    marginBottom: '20px',
    background: 'linear-gradient(90deg, #ffffff 0%, #cbd5e1 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (min-width: 768px)': {
      fontSize: '3.5rem',
      marginBottom: '24px',
    },
  },
  heroSubtitle: {
    fontSize: '1.1rem',
    color: '#94a3b8',
    marginBottom: '30px',
    maxWidth: '500px',
    '@media (min-width: 768px)': {
      fontSize: '1.25rem',
      marginBottom: '40px',
    },
  },
  phoneIllustration: {
    position: 'relative',
    width: '280px',
    height: '280px',
    '@media (min-width: 768px)': {
      width: '350px',
      height: '350px',
    },
  },
  phone: {
    position: 'absolute',
    width: '150px',
    height: '300px',
    background: '#1e293b',
    borderRadius: '25px',
    border: '8px solid #0f172a',
    transform: 'rotate(15deg)',
    zIndex: 2,
    overflow: 'hidden',
    '@media (min-width: 768px)': {
      width: '200px',
      height: '400px',
      borderRadius: '30px',
      border: '10px solid #0f172a',
    },
  },
  screen: {
    width: '100%',
    height: '100%',
    background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  appInterface: {
    width: '80%',
    height: '80%',
    background: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '12px',
    '@media (min-width: 768px)': {
      borderRadius: '15px',
    },
  },
  arElements: {
    position: 'absolute',
    top: '30px',
    right: '0',
    width: '150px',
    height: '150px',
    '@media (min-width: 768px)': {
      width: '200px',
      height: '200px',
      top: '50px',
    },
  },
  arCube: {
    position: 'absolute',
    width: '40px',
    height: '40px',
    background: 'rgba(59, 130, 246, 0.6)',
    transform: 'rotate(45deg)',
    top: '20px',
    right: '20px',
    animation: 'float 6s ease-in-out infinite',
    '@media (min-width: 768px)': {
      width: '60px',
      height: '60px',
      top: '30px',
      right: '30px',
    },
  },
  arSphere: {
    position: 'absolute',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    background: 'radial-gradient(circle at center, rgba(236, 72, 153, 0.6) 0%, transparent 70%)',
    bottom: '15px',
    right: '60px',
    animation: 'float 4s ease-in-out infinite',
    animationDelay: '1s',
    '@media (min-width: 768px)': {
      width: '40px',
      height: '40px',
      bottom: '20px',
      right: '80px',
    },
  },
  frameworks: {
    padding: '60px 5%',
    background: '#0f172a',
    '@media (min-width: 768px)': {
      padding: '100px 5%',
    },
  },
  sectionHeader: {
    textAlign: 'center',
    maxWidth: '700px',
    margin: '0 auto 40px',
    '@media (min-width: 768px)': {
      marginBottom: '60px',
    },
  },
  sectionTag: {
    display: 'inline-block',
    color: '#3b82f6',
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.05em',
    marginBottom: '12px',
    '@media (min-width: 768px)': {
      fontSize: '0.875rem',
      marginBottom: '16px',
    },
  },
  sectionTitle: {
    fontSize: '1.8rem',
    fontWeight: 700,
    marginBottom: '12px',
    lineHeight: 1.3,
    '@media (min-width: 768px)': {
      fontSize: '2.5rem',
      marginBottom: '16px',
    },
  },
  sectionDescription: {
    fontSize: '1rem',
    color: '#94a3b8',
    lineHeight: 1.7,
    '@media (min-width: 768px)': {
      fontSize: '1.125rem',
    },
  },
  frameworkGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '32px',
    },
  },
  frameworkCard: {
    background: '#1e293b',
    borderRadius: '12px',
    padding: '30px',
    transition: 'transform 0.3s ease',
    '@media (min-width: 768px)': {
      padding: '40px',
    },
  },
  frameworkLogo: {
    width: '50px',
    height: '50px',
    borderRadius: '10px',
    background: 'rgba(255, 255, 255, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    '@media (min-width: 768px)': {
      width: '60px',
      height: '60px',
      borderRadius: '12px',
      marginBottom: '24px',
    },
  },
  frameworkTitle: {
    fontSize: '1.3rem',
    fontWeight: 600,
    marginBottom: '12px',
    '@media (min-width: 768px)': {
      fontSize: '1.5rem',
      marginBottom: '16px',
    },
  },
  frameworkText: {
    color: '#94a3b8',
    fontSize: '0.9375rem',
    lineHeight: 1.7,
    marginBottom: '20px',
    '@media (min-width: 768px)': {
      fontSize: '1rem',
      marginBottom: '24px',
    },
  },
  frameworkFeatures: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    '@media (min-width: 768px)': {
      gap: '12px',
    },
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#e2e8f0',
    fontSize: '0.9375rem',
    '@media (min-width: 768px)': {
      fontSize: '1rem',
    },
  },
  featureIcon: {
    color: '#3b82f6',
    fontWeight: 'bold',
  },
  arvrSection: {
    padding: '60px 5%',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    '@media (min-width: 768px)': {
      padding: '100px 5%',
    },
  },
  arvrContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    gap: '40px',
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      gap: '60px',
    },
  },
  arvrText: {
    flex: 1,
    order: 1,
    '@media (min-width: 1024px)': {
      order: 0,
    },
  },
  arvrDescription: {
    fontSize: '1rem',
    color: '#94a3b8',
    margin: '20px 0 24px',
    lineHeight: 1.7,
    '@media (min-width: 768px)': {
      fontSize: '1.125rem',
      margin: '24px 0 32px',
    },
  },
  arvrCapabilities: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '@media (min-width: 768px)': {
      gap: '24px',
    },
  },
  capability: {
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '8px',
    padding: '16px',
    borderLeft: '4px solid #3b82f6',
    '@media (min-width: 768px)': {
      padding: '20px',
    },
  },
  capabilityTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    margin: '0 0 8px 0',
    color: '#e2e8f0',
    '@media (min-width: 768px)': {
      fontSize: '1.25rem',
    },
  },
  capabilityText: {
    color: '#94a3b8',
    fontSize: '0.875rem',
    margin: 0,
    lineHeight: 1.6,
    '@media (min-width: 768px)': {
      fontSize: '0.9375rem',
    },
  },
  arvrVisual: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    order: 0,
    '@media (min-width: 1024px)': {
      order: 1,
    },
  },
  arvrDevice: {
    width: '200px',
    height: '400px',
    background: '#1e293b',
    borderRadius: '30px',
    border: '12px solid #0f172a',
    position: 'relative',
    overflow: 'hidden',
    '@media (min-width: 768px)': {
      width: '250px',
      height: '500px',
      borderRadius: '40px',
      border: '15px solid #0f172a',
    },
  },
  arvrScreen: {
    width: '100%',
    height: '100%',
    background: 'linear-gradient(45deg, #1e3a8a 0%, #1e40af 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arvrElements: {
    width: '80%',
    height: '80%',
    position: 'relative',
  },
  arvrObject: {
    position: 'absolute',
    background: 'rgba(59, 130, 246, 0.6)',
  },
  arvrPlane: {
    position: 'absolute',
    width: '100%',
    height: '20%',
    bottom: '0',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '5px',
  },
  caseStudies: {
    padding: '60px 5%',
    background: '#0f172a',
    '@media (min-width: 768px)': {
      padding: '100px 5%',
    },
  },
  studyGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '32px',
    },
  },
  studyCard: {
    background: '#1e293b',
    borderRadius: '12px',
    padding: '30px',
    '@media (min-width: 768px)': {
      padding: '40px',
    },
  },
  studyHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    '@media (min-width: 768px)': {
      marginBottom: '24px',
    },
  },
  studyLogo: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    background: 'rgba(59, 130, 246, 0.1)',
    marginRight: '12px',
    '@media (min-width: 768px)': {
      width: '48px',
      height: '48px',
      marginRight: '16px',
    },
  },
  studyTitle: {
    fontSize: '1.3rem',
    fontWeight: 600,
    margin: 0,
    '@media (min-width: 768px)': {
      fontSize: '1.5rem',
    },
  },
  studyText: {
    color: '#94a3b8',
    fontSize: '0.9375rem',
    lineHeight: 1.7,
    marginBottom: '24px',
    '@media (min-width: 768px)': {
      fontSize: '1rem',
      marginBottom: '32px',
    },
  },
  studyStats: {
    display: 'flex',
    gap: '20px',
    '@media (min-width: 768px)': {
      gap: '24px',
    },
  },
  statItem: {
    textAlign: 'center',
  },
  statNumber: {
    display: 'block',
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#3b82f6',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '2rem',
    },
  },
  statLabel: {
    display: 'block',
    fontSize: '0.75rem',
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    '@media (min-width: 768px)': {
      fontSize: '0.875rem',
    },
  },
  '@keyframes float': {
    '0%': {
      transform: 'translateY(0px)',
    },
    '50%': {
      transform: 'translateY(-15px)',
    },
    '100%': {
      transform: 'translateY(0px)',
    },
  },
};

export default MobileInnovation;